module.exports = ".input-file {\n  width: 0.1px;\n  height: 0.1px;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  z-index: -1; }\n\n.drop {\n  border: 4px dashed #57c2ec;\n  border-radius: 4px;\n  padding: 8px;\n  margin-left: 8px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/upload/upload-file/upload-file.component.scss
// module id = ./src/app/shared/upload/upload-file/upload-file.component.scss
// module chunks = main